module.exports = __webpack_public_path__ + "img/hawk.729bc29a.png";